/* eslint-disable eqeqeq */
import React from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
//i18n
import { useTranslation } from "react-i18next";
import OtpInput from "react-otp-input";

import { Helmet } from "react-helmet";
import protect from "../../../assets/images/key.svg";
import logo from "../../../assets/images/logo_new.svg";
import CustomButton from "../../../components/customButton/customButton";
import HookForm from "../../../components/hookForm/hookForm";

/**
 * OTP Verification Component.
 * @param {{object}} props - The props object containing the necessary data and functions.
 * @returns The OTP verification component.
 */
const OtpVerificationComponnet = (props) => {
  /**
   * Destructures the necessary variables and functions from the props object.
   * @param {{object}} props - The props object containing the necessary variables and functions.
   * @returns None
   */
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();
  const {
    busy,
    onFormSubmit,
    digitValue,
    onOtpChange,
    timer,
    handleResendClick,
    otpForm,
    otpErrorCode,
    otpErrorMessage,
    email,
  } = props;

  return (
    <React.Fragment>
      <Helmet>
        <title>OTP Verification | RizzTix </title>
      </Helmet>
      <div className="authPages">
        <Container>
          <Row className="justify-content-center">
            <div className="logoDiv">
              <img src={logo} alt="logo" />
            </div>
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden forgotStyle">
                <div className="bg-primary topContainRow">
                  <Col className="col-7">
                    <h5 className="mb-0 text-primary">{t("VERIFY_NOW")}</h5>
                    <p className="text-primary">
                      {t("ENTER_THE_VERIFICATION_CODE_TO_RESET_PASSWORD")}
                    </p>
                  </Col>
                  <Col className="col-5 d-flex justify-content-end">
                    <img src={protect} alt="" className="img-fluid" />
                  </Col>
                </div>
                <CardBody className="Card_Body">
                  <div className="p-3">
                    <p className="mb-4 forgotTxtStyle">
                      {t(
                        "PLEASE_ENTER_THE_4_DIGIT_VERIFICATION_CODE_SENT_TO_YOUR_REGISTERED_EMAIL_ADDRESS"
                      )}{" "}
                      <br></br>
                      <br></br>
                      <span className="fw-semibold">{email}</span>
                    </p>
                    <HookForm
                      defaultForm={{}}
                      className="form-horizontal"
                      onSubmit={(e) => onFormSubmit(e)}
                    >
                      {(formMethod) => {
                        return (
                          <>
                            <Row className="otpForm">
                              <OtpInput
                                rules={otpForm.otp.validate}
                                name={otpForm.otp.name}
                                errors={formMethod?.formState.errors}
                                value={digitValue}
                                onChange={onOtpChange}
                                numInputs={4}
                                separator={<span> </span>}
                                isInputNum={true}
                                inputType="tel"
                                containerStyle="otpContainer mb-4"
                                inputStyle={
                                  digitValue === ""
                                    ? " otpInputNoneStyle"
                                    : "otpInputFillStyle otpInputNoneStyle"
                                }
                                renderInput={(props) => (
                                  <input type="number" {...props} />
                                )}
                                id="digitfour"
                              />
                            </Row>
                            <div className="mb-4 resendCodeStyle">
                              {otpErrorCode ? (
                                <p className="text-danger mb-2">{otpErrorMessage}</p>
                              ) : null}
                              <p>{t("DIDN’T_RECEIVE_THE_CODE")}</p>
                              {timer > 0 && (
                                <p className="resendCodeTimerStyle">
                                  {t("RESEND_CODE_IN")} <span>{timer}s</span>
                                </p>
                              )}
                              {(!timer > 0 || otpErrorCode === "OTP_EXPIRED") && (
                                <Button onClick={handleResendClick}>
                                  {t("RESEND_CODE")}
                                </Button>
                              )}
                            </div>
                            <div className="d-grid mb-3">
                              <CustomButton
                                className="btn darkBtn btn-block"
                                type="submit"
                                title={t("VERIFY")}
                                disabled={digitValue.length < 4}
                                loading={busy}
                              />
                            </div>
                          </>
                        );
                      }}
                    </HookForm>
                  </div>
                </CardBody>
              </Card>
              <div className="copyRightTextStyle text-center">
                <p>{`@${currentYear} ${t("COPYRIGHTS_BY_SIGN_IN")}`}</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default OtpVerificationComponnet;
